var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMegaphoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.896,
    height: 49,
    viewBox: "0 0 49.896 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#4eba9a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "megaphone",
    transform: "translate(9.354 -23.794) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(30.849 4.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M60.4,32.079,48.351,20.032a3.195,3.195,0,0,0-4.907,4.046l-.017.084a22.29,22.29,0,0,1-6.115,11.427l-5.526,5.526a3.193,3.193,0,0,0,0,4.518L34.8,48.644a3.193,3.193,0,0,0,4.518,0l.753-.753,5.271,5.271a3.194,3.194,0,0,0,4.518-4.518L47.6,46.385l.753-.753a3.193,3.193,0,0,0,0-4.518l-.512-.512A22.293,22.293,0,0,1,56.268,37l.085-.017A3.2,3.2,0,0,0,60.4,36.6h0A3.2,3.2,0,0,0,60.4,32.079ZM37.809,47.138a1.064,1.064,0,0,1-1.506,0l-3.012-3.012a1.064,1.064,0,0,1,0-1.506l5.271-5.271,4.518,4.518ZM48.351,50.15a1.065,1.065,0,0,1-1.506,1.506l-5.271-5.271,1.506-1.506Zm-3.765-6.777c.32-.32.8-.81,1.556-1.456l.7.7a1.064,1.064,0,0,1,0,1.506l-.753.753Zm.045-2.966L40.023,35.8a24.385,24.385,0,0,0,5.184-9.875l9.3,9.3A24.384,24.384,0,0,0,44.631,40.407Zm14.261-5.316a1.064,1.064,0,0,1-1.506,0L45.339,23.044a1.065,1.065,0,0,1,1.506-1.506L58.892,33.585A1.066,1.066,0,0,1,58.892,35.091Z",
    transform: "translate(-30.849 -19.098)",
    fill: "#fff",
    stroke: "#4eba9a",
    strokeWidth: 0.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneIcon);
export default __webpack_public_path__ + "static/media/megaphoneIcon.52c754374a0b13516e32308292bd9b8f.svg";
export { ForwardRef as ReactComponent };